export default __webpack_public_path__ + "static/media/shoe1.5ed667f9.jpg";